import { mockBoardUuid } from '@canvas/frame-api-noop';

import { currentDevelopmentUIState } from './dev-ui-state.ts';
import { isOfflineMode } from './is-dev-mode.ts';

export const getBoardIdForLocalDevelopment = () => {
  if (isOfflineMode()) {
    // There's no such thing as a real "board" in offline mode so we have to
    // make one up
    return mockBoardUuid;
  } else {
    return currentDevelopmentUIState.boardId;
  }
};
